<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <div v-if="props.row.annee || props.row.date_appel" slot="numero_fiche" slot-scope="props" class="slot-date">
        <router-link  :to="getSrc(props.row.id)">
          <span class="badge badge-warning p-2 mb-1 clickable" @click.prevent="showFiche(props.row)">FC{{ props.row.annee }}-{{ props.row.numero_annee.toString().padStart(5,'0') }}</span>
        </router-link>
        <br>
        <span class="badge badge-success p-2">{{ formatDateHeure(props.row.date_appel) }}</span>
      </div>
      <div v-if="props.row.contact_nom || props.row.contact_prenom" slot="nom_contact" slot-scope="props">
        <span style="color:#C72C48;">{{ props.row.contact_civ }} {{ props.row.contact_prenom ? props.row.contact_prenom[0].toUpperCase() + props.row.contact_prenom.slice(1).toLowerCase() : '' }}  {{ props.row.contact_nom }}</span><br>
        <span>{{ props.row.structure_nom }} ({{ props.row.structure_siren }} - {{ props.row.segment }})</span><br>
        <span style="color:#225CB5;"><i class="fa fa-folder-open"></i><i> {{ props.row.beneficiaire_prenom ? props.row.beneficiaire_prenom[0].toUpperCase() + props.row.beneficiaire_prenom.slice(1).toLowerCase() : ''}}  {{ props.row.beneficiaire_nom }}</i></span><br>
        <span>{{ props.row.demande_objet }}</span>
      </div>
      <div v-if="props.row.contact_tel" slot="tel_contact" slot-scope="props">
        <span><strong>{{ props.row.contact_tel.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5') }}</strong></span><br>
        <span v-html="props.row.dernier_suivi"></span>
      </div>
      <div v-if="props.row.type" slot="criticite" slot-scope="props" class="text-center">
        <span :class="props.row.type == 'U' ? 'badge badge-danger p-2' : 'badge badge-warning p-2'">{{ props.row.type }}</span>
      </div>
      <div v-if="props.row.domaine_libelle || props.row.garantie" slot="domaine_libelle" slot-scope="props" class="text-center">
            <span>{{ props.row.domaine_libelle }}</span><br>
            <span>{{ props.row.garantie }}</span>
          </div>
      <div v-if="props.row.gestionnaire" slot="gestionnaire" slot-scope="props">
        <span style="color:#008000;">{{ props.row.gestionnaire.prenom ? props.row.gestionnaire.prenom[0].toUpperCase() + '. ' : '' }}  {{ props.row.gestionnaire.nom }}</span>
      </div>
      <div v-if="props.row.status" slot="statut" slot-scope="props" @click.prevent="showFiche(props.row)" class="clickable text-center">
        <span :class="getClassStatus(props.row)">{{ props.row.status.libelle_bo }}</span>
      </div>
      <div slot="selection" slot-scope="props" v-if="hasRule(rules.CAN_CLOTURE_FICHE_MASSE) && props.row.status.libelle_bo != 'CL'">
        <b-form-checkbox v-model="selectedRows" :value="props.row.id"></b-form-checkbox>
      </div>
      <div slot="h__selection" v-if="hasRule(rules.CAN_CLOTURE_FICHE_MASSE)">
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          aria-describedby="items"
          aria-controls="items"
          @change="toggleAll"
        >
        </b-form-checkbox>
      </div>
      <div slot="afterTable">
        <b-row>
          <b-col sm="12">
            <b-button v-if="hasRule(rules.CAN_CLOTURE_FICHE_MASSE)" type="button" @click="openModalCloturerMasse()" class="pull-right ml-1 mr-1 mt-1" size="md"
                      variant="success">
              <i class="fa fa-eraser fa-rotate-180" title="Clôturer les fiches en masse"></i>Clôturer en masse
            </b-button>
          </b-col>
        </b-row>
      </div>
    </v-server-table>
    <b-modal no-close-on-esc no-close-on-backdrop hide-header-close centered id="modal-commentaireCloture" ref="modal-commentaireCloture" title="Cloture des fiches en masse">
      <label><b>Indiquez le motif de cloture</b></label>
      
        <b-row>
          <b-form-textarea id="commentaireCloture" v-model="commentaireCloture"></b-form-textarea>
        </b-row>
        <template v-slot:modal-footer>
          <div class="w-100 text-right">
            <button type="button" class="btn btn-secondary mr-1" @click="closeModalCommentaireCloture()">Annuler les clôtures</button>
            <button type="button" @click="cloturer()" class="btn btn-warning"><i class="fa fa-save"></i>
               Confirmer les clôtures
            </button>
          </div>
        </template>
      </b-modal>
  </div>
</template>

<script>
  import { formatDate } from "@/utils/communHelper"
  import { downloadFile, isEmpty } from "@/utils/fileHelper"
  import { espaceRCRules as rules, hasRule } from '@/utils/rulesHelper'

  export default {
    name: "FichesTable",
    props: ["tableEntry"],
    data() {
      let self = this
      return {
        formatDate,
        isEmpty,
        url: '',
        columns: ['numero_fiche', 'nom_contact', 'tel_contact', 'criticite', 'domaine_libelle', 'gestionnaire', 'statut', 'selection'],
        selectedRows: [],
        allSelected: false,
        indeterminate: false,
        commentaireCloture: '',
        hasRule,
        rules,
        options: {
          headings: {
            numero_fiche: 'N° Fiche\nDate/Heure',
            nom_contact: 'Nom Contact\nRéf. Dossier/Demande client',
            tel_contact: 'N° de Tel\nDernière mise à jour',
            criticite: 'Criticité',
            domaine_libelle: 'BO Dest.\nGarantie',
            gestionnaire: 'Prise en Charge',
            statut: 'Statut',
            selection: ''
          },
          columnsClasses: {
            numero_fiche: 'col-xs',
            nom_contact: 'pre-formatted sort-top tooltip-cell position-r',
            tel_contact: 'pre-formatted tooltip-cell position-r',
            selection: 'align-middle text-center position-r',
          },
          resizableColumns: true,
          perPage: 10,
          filterable: false,
          sortable: ['numero_fiche', 'nom_contact', 'criticite', 'statut'],
          perPageValues: [10, 25, 50],
          requestFunction: function (data) {
            self.url = '/espaceRelationClient/fiches/search'
            data["date_appel_du"] = self.tableEntry.date_appel_du
            data["date_appel_au"] = self.tableEntry.date_appel_au
            data["numero_fiche"] = self.tableEntry.numero_fiche
            data["criticite"] = self.tableEntry.criticite
            data["nom_contact"] = self.tableEntry.nom_contact
            data["tel_contact"] = self.tableEntry.tel_contact
            data["mail_contact"] = self.tableEntry.mail_contact
            data["raison_sociale"] = self.tableEntry.raison_sociale
            data["structure_siren"] = self.tableEntry.structure_siren
            data["structure_nic"] = self.tableEntry.structure_nic
            data["nom_beneficiaire"] = self.tableEntry.nom_beneficiaire
            data["prenom_beneficiaire"] = self.tableEntry.prenom_beneficiaire
            data["nir_beneficiaire"] = self.tableEntry.nir_beneficiaire
            data["nir_cle"] = self.tableEntry.nir_cle
            data["produit"] = self.tableEntry.produit
            data["garantie"] = self.tableEntry.garantie
            data["status"] = self.tableEntry.status
            data["createur"] = self.tableEntry.createur
            data["destinataire_libelle"] = self.tableEntry.destinataire_libelle
            data["gestionnaire"] = self.tableEntry.gestionnaire
            data["noSearch"] = self.$parent.noSearch
            self.$store.commit("IS_LOADING", true)

            return axios.get(self.url, {
              params: data
            })
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          }
        }
      };
    },
    watch: {
      selectedRows(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.allProfil.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
    },
    methods: {
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-"
        return date;
      },
      onLoaded() {
        this.$store.commit("IS_LOADING", false)
      },
      showFiche(fiche) {
        window.open('/espace-rc/fiche/show/' + fiche.id, '_blank')
      },
      toggleAll(checked) {
        this.selectedRows = checked ? this.$refs.table.data.map(item => {
          return item.id
        }) : []
      },
      closeModalCommentaireCloture(){
        this.$refs['modal-commentaireCloture'].hide();
        this.commentaireCloture = '';
        this.selectedRows = [];
      },
      openModalCloturerMasse(){
        if(this.selectedRows.length === 0){
          this.$swal({
                    position: "top",
                    type: "error",
                    title: "Attention !!",
                    text: "Vous devez choisir au moins 1 fiche",
                    showConfirmButton: false,
                    timer: 3000
                  })
          return false;
        }
        this.$refs['modal-commentaireCloture'].show();
      },
      cloturer(){
        let self = this;
        if(this.selectedRows.length === 0){
          this.$swal({
                    position: "top",
                    type: "error",
                    title: "Attention !!",
                    text: "Vous devez choisir au moins 1 fiche",
                    showConfirmButton: false,
                    timer: 3000
                  })
          return false;
        }
  

        let dataPost = { ficheIds: this.selectedRows, commentaireCloture : this.commentaireCloture }
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .post("/espaceRelationClient/fiches/cloturer", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$refs.table.refresh();
            this.$refs['modal-commentaireCloture'].hide();
            this.commentaireCloture = '';
            this.selectedRows = [];
            let textSwal = 'Clotures réalisées avec succès !';
            let typeSwal = 'success';
            let titleSwal = 'Succès';
            let timeSwal = 5000;
            self.$swal({
              position: "top",
              type: typeSwal,
              title: titleSwal,
              text: textSwal,
              showConfirmButton: false,
              timer: timeSwal
            })
        })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false)
            console.log(error)
            let errorText = "Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI."
            if (error.response && error.response.status === 403) {
              errorText = "Vous n'êtes pas autorisé à effectuer cette action"
            }
            if (error.response && error.response.status === 424) {
              errorText = error.response.data.message
            }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          })
            
      },
      getSrc(id) {
        if (!isEmpty(id)) {
              return {
                path: '/espace-rc/fiche/show/' + id
              }
        } else {
              return null;
        }
      },
      getClassStatus(fiche) {
        let cssClass = '';
        switch (fiche.status.libelle_bo) {
          case 'AV':
            cssClass = 'badge badge-danger p-2';
            break;
          case 'AT':
            cssClass = 'badge badge-warning p-2';
            break;
          case 'EC':
            cssClass = 'badge badge-primary p-2';
            break;
          case 'CL':
            cssClass = 'badge badge-success p-2';
            break;
          default:
            cssClass = 'badge badge-secondary p-2';
        }
        return cssClass;
      },
    }
  }
</script>

<style scoped>
  .VueTables__search-field input {
    width: 240px !important;
  }
</style>
